import type { AvatarUrls } from '@atlassian/jira-shared-types/src/rest/jira/user.tsx';
import type { ENTITY_LIMIT_TYPE } from './constants.tsx';

type ProjectId = string;
type ProjectKey = string;

type ValueOf<T> = T[keyof T];

export const ProjectOnboardingStatusEnum = {
	UNKNOWN: 'UNKNOWN',
	TASK_CREATION_FAILED: 'TASK_CREATION_FAILED',
	QUEUEING_FAILED: 'QUEUEING_FAILED',
	QUEUED: 'QUEUED',
	IN_PROGRESS: 'IN_PROGRESS',
	DONE: 'DONE',
	FAILED: 'FAILED',
} as const;

export const ProjectTemplateEnum = {
	DISCOVERY: 'jira.polaris:discovery',
	BLANK: 'jira.polaris:blank-project',
	ROADMAP: 'jira.polaris:roadmap',
	PRIORITIZATION: 'jira.polaris:prioritization',
	PORTFOLIO_MANAGEMENT: 'jira.polaris:portfolio',
	BLUEPRINTS: 'jira.polaris:blueprints',
	FROM_EXISTING_PROJECT: 'jira:template-generated-from-existing-project',
	PORTFOLIO_ROADMAP: 'jira.polaris:portfolio-roadmap',
} as const;

export type PolarisProjectTemplate = {
	onboardingStatus: ValueOf<typeof ProjectOnboardingStatusEnum>;
	initialProjectTemplate: ValueOf<typeof ProjectTemplateEnum>;
};

export type EntityLimitType = (typeof ENTITY_LIMIT_TYPE)[keyof typeof ENTITY_LIMIT_TYPE];

export type EntityLimits = {
	[K in EntityLimitType]?: number;
};

// eslint-disable-next-line jira/export/restrict-types-re-export
export type ProjectAvatarUrls = AvatarUrls;

export type ProjectMetadata = {
	id: ProjectId;
	key: ProjectKey;
	name: string;
	avatarUrls: ProjectAvatarUrls;
};
